import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import EventBlock from './EventBlock'

import styles from '../../../../css/scheduler.module.css'

function DateBlock ({
  data, today, label, crossInto, crossOutOf, day, handleUpdateEvent, newEvent,
}) {
  const classes = useMemo(() => {
    const multi = data.reduce((acc, cur) => {
      if (cur.duration.cross) acc = true
      return acc
    }, false)
    const result = []
    if (multi) result.push(styles.multi_day)
    if (today) result.push(styles.today)
    return result
  }, [data, today])

  const className = useMemo(() => classes.join(' '), [classes])

  const height = useMemo(() => {
    if (data.length < 1) {
      return {
        padding: '20px',
        height: '95px',
      }
    }
    let blocks = 0
    blocks = data.reduce((acc, cur) => {
      if (!cur) return acc
      if (cur.duration.cross) {
        return acc + cur.duration.size
      }
      return acc + cur.duration.size + 1
    }, 0)
    let height = blocks > 0 ? 55 * (blocks - 1) + 95 : 95
    if (!crossInto && data.length === 1) height -= 10
    if (crossInto) height += 50
    if (crossInto && day === 0 && crossOutOf) height -= 10
    if (!crossOutOf && day !== 6) height -= 10

    const padding = '20px'

    return {
      padding,
      height: `${height}px`,
    }
  }, [data, crossInto, crossOutOf, day])

  const padding = useMemo(() => {
    let paddingTop = '0px'
    if (
      crossInto &&
      day !== 0
    ) {
      paddingTop = '50px'
    }
    return {
      paddingTop,
    }
  }, [crossInto, day])

  return (
    <div className={`${styles.date} ${className}`} style={height} onClick={() => newEvent(day)} role='dateblock'>
      <div className={styles.date_text}>
        <strong>{label}</strong>
      </div>
      <div style={padding}>
        {data.map((e) => (
          <EventBlock key={e.human} event={e} handleUpdateEvent={handleUpdateEvent} />
        ))}
      </div>
    </div>
  )
}

DateBlock.propTypes = {
  label: PropTypes.string,
  data: PropTypes.array,
  crossInto: PropTypes.bool,
  crossOutOf: PropTypes.bool,
  handleUpdateEvent: PropTypes.func.isRequired,
}

export default DateBlock
